// START_MODULE components_layout_contentsectioncontainer_contentsectioncontainer_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';

interface ContentSectionContainerProps {
  type?: 'large' | 'middle'
}

export const ContentSectionContainer = styled.div<ContentSectionContainerProps>`
  ${({ type = 'large' }) => css`
    padding: ${type === 'large' ? 80 : 40}px 240px;

    @media (max-width: 1400px) {
      padding: ${type === 'large' ? 80 : 40}px 100px;
    }

    @media (max-width: 1000px) {
      padding: ${type === 'large' ? 80 : 40}px 20px;
    }

    @media (max-width: 500px) {
      padding: ${type === 'large' ? 80 : 40}px 8px;
    }

    h4 {
      font-size: 1.5rem;
      margin-bottom: 16px;
    }
  `};
`;

// END_MODULE components_layout_contentsectioncontainer_contentsectioncontainer_ts
